import React from "react";
import ActionBar from "../../common/ActionBar";
import CustomTable from "../../common/CustomTable/CustomTable";
import styled from "styled-components";
import CaseService from "../../../services/CaseService";
import queryString from "query-string";
import { useState } from "react";
import _ from "lodash";
import { useRef } from "react";
import {
  getFileFormat,
  getFileName,
  parseTimeStamp,
} from "../../../helpers/functions";
import moment from "moment";
import labels from "../../../helpers/labels.json";
import {
  ArrowDownward,
  CheckCircle,
  Description,
  InsertDriveFileOutlined,
  ReceiptOutlined,
  Visibility,
} from "@material-ui/icons";
import { Tooltip, IconButton } from "@material-ui/core";
import { CloseBtn } from "../../internal/BulkUpdate";
import { CustomInputField } from "../../common/FormInputs";
import { PrimaryCTAButton } from "../../common/Buttons";
import {
  ModalOverlay,
  ModalBox,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "../../common/CaseDetails";
import { useSnackbar } from "notistack";
import InvoiceModal from "./component/InvoiceModal";
import Part2InvoiceModal from "./component/Part2InvoiceModal";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import DocViewers from "../../internal/DrawerTable/DocViewer";
import useUser from "../../../hooks/useUser";
import AssignCaseManagerBulkCase from "../AssignCaseManagerBulkCase";

async function getUploads(query = "") {
  try {
    const response = await CaseService.bulkUpload(query);
    return { ...response };
  } catch (error) {
    return error;
  }
}

export default function BulkUploads() {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [lotModal, setLotModal] = useState({
    open: false,
    row: null,
  });
  const [lotNumber, setLotNumber] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [invoiceModal, setInvoiceMoadl] = useState({ state: false });
  const [part2Modal, setPart2Modal] = useState({ state: false });
  const [docview, setDocView] = useState({ state: false });
  const [assignCaseManagerModal, setAssignCaseManagerModal] = useState({
    state: false,
  });
  const [approvingBatchIds, setApprovingBatchIds] = useState([]);
  const [approvedBatchIds, setApprovedBatchIds] = useState([]);
  const { userObject } = useUser();
  const canGenerateInvoice = Boolean(userObject?.account);
  const canApprovePart2 = Boolean(userObject?.isSuperCaseManager);

  const actions = [
    {
      text: "Assign Case Manager",
      hidden: !userObject?.isSuperCaseManager,
      props: {
        onClick: () => setAssignCaseManagerModal({ state: true }),
      },
    },
  ];

  async function assignLotToCase(payload) {
    try {
      const response = await CaseService.assignLotToCase(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, { variant: "success" });
      }
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    } finally {
      setLotNumber("");
      setLotModal({ open: false });
      MTRef.current.onQueryChange("");
    }
  }

  async function approveBatch(batchId) {
    if (!batchId || approvedBatchIds.includes(batchId)) return;

    try {
      setApprovingBatchIds((ids) => [...ids, batchId]);
      const response = await CaseService.updateStatusByBatch({
        status: "awaitingRespondentAcceptance",
        counterClaimDeadline: 15,
        batchId,
      });
      setApprovedBatchIds((ids) => [...ids, batchId]);
      enqueueSnackbar(response?.message || "Batch approved successfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.message || "Unable to approve batch", {
        variant: "error",
      });
    } finally {
      setApprovingBatchIds((ids) => ids.filter((id) => id !== batchId));
      MTRef.current.onQueryChange("");
    }
  }

  //   async function handleSubmitBatch(batchId) {
  //   try {
  //     setIsSubmitting(true);
  //     const response = await CaseService.reprocessDuplicates({
  //       allowDuplicate: true,
  //       batchId: batchId,
  //     });
  //     if (response?.message) {
  //       enqueueSnackbar(response?.message, { variant: "success" });
  //     }
  //   } catch (error) {
  //     enqueueSnackbar(error?.message, {
  //       variant: "error",
  //     });
  //   } finally {
  //     setIsSubmitting(false);
  //     setSubmitModal({ open: false, row: null });
  //     MTRef.current.onQueryChange("");
  //   }
  // }

  /*

  async function deleteuploadeFile(id) {
    try {
      setLoader({ state: true, message: "Delete uploade file..." });
      const response = await CaseService.deleteuploadeFile({
        id: id,
      });
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
    }
  } 

  */

  // percentage widths (sum = 100) keep the table fitted without horizontal scroll
  const colWidth = (width, extra = {}) => ({
    headerStyle: { width, ...extra },
    cellStyle: { width, ...extra },
  });

  const columns = [
    {
      field: "url",
      title: labels.file,
      sorting: false,
      render: (rowData) => {
        const name = decodeURI(getFileName(rowData.url));
        return (
          <FileCell title={name}>
            <FileIcon>
              <InsertDriveFileOutlined style={{ fontSize: 17 }} />
            </FileIcon>
            <Ellipsis bold>{name}</Ellipsis>
          </FileCell>
        );
      },
      ...colWidth("20%", { paddingLeft: "20px" }),
    },
    {
      field: "lot",
      title: "Lot No",
      sorting: false,
      render: (rowData) => {
        const fileUrl = rowData?.updatedFileWithCaseId;
        if (rowData?.lotNo) {
          return <LotChip>Lot {rowData?.lotNo}</LotChip>;
        }
        if (fileUrl) {
          return (
            <LotButton
              placeholder="Lot No"
              onClick={() => {
                setLotModal({ open: true, row: rowData });
                setLotNumber("");
              }}
              readOnly
            />
          );
        }
        return <Muted>-</Muted>;
      },
      ...colWidth("8%"),
    },
    {
      field: "entity.name",
      title: labels.uploaded_for_party,
      sorting: false,
      render: (rowData) => (
        <Ellipsis bold title={rowData?.entity?.name}>
          {rowData?.entity?.name || "-"}
        </Ellipsis>
      ),
      ...colWidth("15%"),
    },
    {
      field: "owner.name",
      title: labels.uploaded_by,
      sorting: false,
      render: (rowData) => (
        <OwnerCell title={rowData?.owner?.name}>
          <Avatar>
            {(rowData?.owner?.name || "?").charAt(0).toUpperCase()}
          </Avatar>
          <Ellipsis>{rowData?.owner?.name || "-"}</Ellipsis>
        </OwnerCell>
      ),
      ...colWidth("13%"),
    },
    {
      field: "created_at",
      title: labels.uploaded_date,
      sorting: true,
      render: (rowData) => (
        <DateText>
          {moment(parseTimeStamp(rowData.created_at)).format("DD MMM YYYY")}
        </DateText>
      ),
      ...colWidth("10%"),
    },
    {
      field: "updatedFileWithCaseId",
      title: "Files",
      sorting: false,
      render: (rowData) => {
        const fileUrl = rowData?.updatedFileWithCaseId;

        return (
          <IconGroup>
            <Tooltip
              title={
                fileUrl ? "Preview File with Case ID" : "File not available"
              }
            >
              <span>
                <IconButton
                  size="small"
                  disabled={!fileUrl}
                  onClick={() =>
                    setDocView({
                      state: true,
                      url: fileUrl,
                      name: getFileName(fileUrl),
                      format: getFileFormat(fileUrl),
                    })
                  }
                  style={{ background: fileUrl ? "#f0f7ff" : "#f5f5f5" }}
                >
                  <Visibility
                    style={{
                      fontSize: 18,
                      color: fileUrl ? "#00838c" : "#bdbdbd",
                    }}
                  />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              title={
                fileUrl ? "Download File with Case ID" : "File not available"
              }
            >
              <span>
                <IconButton
                  size="small"
                  disabled={!fileUrl}
                  onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                  style={{ background: fileUrl ? "#f0f7ff" : "#f5f5f5" }}
                >
                  {fileUrl ? (
                    <ArrowDownward style={{ fontSize: 18, color: "#00838c" }} />
                  ) : (
                    <Description style={{ fontSize: 18, color: "#bdbdbd" }} />
                  )}
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Download Original File">
              <IconButton
                size="small"
                onClick={() => window.open(rowData.url, "_blank")}
                style={{ background: "#e8f5e9" }}
              >
                <ArrowDownward style={{ fontSize: 18, color: "#2e7d32" }} />
              </IconButton>
            </Tooltip>
          </IconGroup>
        );
      },
      ...colWidth("11%"),
    },
    {
      field: "",
      title: "Invoice",
      sorting: false,
      hidden: !canGenerateInvoice && !canApprovePart2,
      render: (rowData) => (
        <InvoiceActions>
          {canGenerateInvoice && (
            <PillButton
              type="button"
              title="Generate Invoice"
              onClick={() =>
                setInvoiceMoadl({
                  state: true,
                  documentId: rowData?.id,
                  updatedFileWithCaseId: rowData?.updatedFileWithCaseId,
                })
              }
            >
              <ReceiptOutlined style={{ fontSize: 14 }} />
              <span>Generate Invoice</span>
            </PillButton>
          )}
          {canApprovePart2 && (
            <PillButton
              type="button"
              variant="secondary"
              title="Part 2 Invoice"
              onClick={() =>
                setPart2Modal({
                  state: true,
                  documentId: rowData?.id,
                  fileName: decodeURI(getFileName(rowData?.url)),
                })
              }
            >
              <ReceiptOutlined style={{ fontSize: 14 }} />
              <span>Approval for Part 2 Invoice</span>
            </PillButton>
          )}
        </InvoiceActions>
      ),
      ...colWidth("12%"),
    },

    //  {
    //   field: "",
    //   title: "Allow Duplicate",
    //   sorting: false,
    //   render: (rowData) => (
    //     rowData?.duplicateContractNos !== "[]" && (
    //       <PrimaryCTAButton
    //         style={{ padding: "8px 16px", fontSize: "13px" }}
    //         disabled={rowData?.allowDuplicate}
    //         onClick={() => setSubmitModal({ open: true, row: rowData })}
    //       >
    //         Action
    //       </PrimaryCTAButton>
    //     )
    //   ),
    // },

    {
      field: "approve",
      title: "Move / Approve",
      sorting: false,
      ...colWidth("11%"),
      render: (rowData) => {
        const isApproved =
          // (rowData?.allowDuplicate && rowData?.parentBatchId) ||
          approvedBatchIds.includes(rowData?.id) ||
          rowData?.batchStatus === "awaitingRespondentAcceptance";
        const isApproving = approvingBatchIds.includes(rowData?.id);
        const fileUrl = rowData?.updatedFileWithCaseId;

        if (!fileUrl) return <Muted>-</Muted>;
        if (isApproved) {
          return (
            <ApprovedBadge>
              <CheckCircle style={{ fontSize: 15 }} />
              Approved
            </ApprovedBadge>
          );
        }
        return (
          <PrimaryCTAButton
            style={{ padding: "6px 14px", fontSize: "12.5px", borderRadius: 8 }}
            type="button"
            disabled={isApproving}
            onClick={() => approveBatch(rowData?.id)}
          >
            {isApproving ? "Approving..." : "Approve"}
          </PrimaryCTAButton>
        );
      },
    },

    /*
    {
      field: "actions",
      title: "",
      hidden: userObject?.isSuperCaseManager ? false : true,
      sorting: false,
      cellStyle: {
        width: 60,
      },
      headerStyle: {
        width: 60,
      },
      render: (rowData) => (
        <DeleteButtonContainer onClick={() => deleteuploadeFile(rowData.id)}>
          <DeleteIcon>✕</DeleteIcon>
        </DeleteButtonContainer>
      ),
    },
    */
  ];

  const data = (query) =>
    new Promise((resolve, reject) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
        query: query.search,
      };
      if (query.search) {
        params.search = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getUploads(stringParams)
        .then((result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  return (
    <>
      <ActionBar
        actions={actions}
        breadcrumbs={[
          _.startCase(labels.cases),
          _.startCase(labels.bulk_uploads),
        ]}
      />
      <AssignCaseManagerBulkCase
        modal={assignCaseManagerModal}
        setModal={setAssignCaseManagerModal}
      />
      <Padding>
        <TableCard>
          <CardHeader>
            <div>
              <CardTitle>Bulk Uploads</CardTitle>
              <CardSubtitle>
                Uploaded case files, lot assignment, invoices and approvals
              </CardSubtitle>
            </div>
            {state?.total != null && (
              <CountChip>{state.total} uploads</CountChip>
            )}
          </CardHeader>
          <CustomTable
            {...{
              data,
              state,
              MTRef,
              columns,
            }}
            hidePagination={state?.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            singularTitle=""
            hideFilterBar={true}
            placeholderText={"Search"}
            // noToolbar
          />
        </TableCard>
      </Padding>
      {lotModal.open && (
        <ModalOverlay
          onClick={(e) =>
            e.target === e.currentTarget &&
            setLotModal({ open: false, row: null })
          }
        >
          <ModalBox onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>Enter Lot Number</ModalTitle>
              <CloseBtn onClick={() => setLotModal({ open: false })}>
                ✕
              </CloseBtn>
            </ModalHeader>
            <ModalBody>
              <CustomInputField
                variant="outlined"
                placeholder="Enter Lot Number"
                value={lotNumber}
                onChange={(e) => setLotNumber(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <PrimaryCTAButton
                type="button"
                style={{ width: "100px", padding: "10px 10px" }}
                disabled={!lotNumber}
                onClick={() => {
                  const lotNo = Number(lotNumber);
                  assignLotToCase({
                    batchId: lotModal.row?.id,
                    lotNo,
                  });
                }}
              >
                Update
              </PrimaryCTAButton>
            </ModalFooter>
          </ModalBox>
        </ModalOverlay>
      )}

      {invoiceModal?.state && (
        <InvoiceModal
          open={invoiceModal?.state}
          onClose={() => setInvoiceMoadl({ state: false })}
          documentId={invoiceModal?.documentId}
          updatedFileWithCaseId={invoiceModal?.updatedFileWithCaseId}
        />
      )}

      {part2Modal?.state && (
        <Part2InvoiceModal
          open={part2Modal?.state}
          onClose={() => setPart2Modal({ state: false })}
          documentId={part2Modal?.documentId}
          fileName={part2Modal?.fileName}
        />
      )}

      {docview?.state && (
        <DocViewers
          docview={docview}
          setDocView={setDocView}
          fileDownload={false}
        />
      )}

      {/* {submitModal.open && (
        <ModalOverlay
          onClick={(e) =>
            e.target === e.currentTarget &&
            setSubmitModal({ open: false, row: null })
          }
        >
          <ModalBox onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>Confirm Submission</ModalTitle>
              <CloseBtn onClick={() => setSubmitModal({ open: false, row: null })}>
                ✕
              </CloseBtn>
            </ModalHeader>
            <ModalBody>
              <p style={{ margin: "0", fontSize: "14px" }}>
                Do you want to confirm this action?
              </p>
            </ModalBody>
            <ModalFooter>
              <PrimaryCTAButton
                type="button"
                style={{ width: "auto", padding: "10px 20px", marginRight: "10px" }}
                onClick={() => setSubmitModal({ open: false, row: null })}
              >
                Cancel
              </PrimaryCTAButton>
              <PrimaryCTAButton
                type="button"
                style={{ width: "auto", padding: "10px 20px" }}
                disabled={isSubmitting}
                onClick={() => {
                  handleSubmitBatch(submitModal.row?.id);
                }}
              >
                {isSubmitting ? "Submitting..." : "Okay"}
              </PrimaryCTAButton>
            </ModalFooter>
          </ModalBox>
        </ModalOverlay>
      )} */}
    </>
  );
}

const Padding = styled.div`
  padding: 28px 35px 35px;
`;

const TableCard = styled.div`
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04);
  padding: 20px 20px 8px;

  .MuiTableContainer-root,
  .MuiPaper-root > div,
  .MuiPaper-root > div > div {
    overflow-x: hidden !important;
  }
  .MuiTable-root {
    width: 100% !important;
    table-layout: fixed !important;
  }
  .MuiTableHead-root th {
    background: #f8fafc;
    color: #64748b;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1.3;
    padding: 12px 8px;
    white-space: normal;
  }
  .MuiTableBody-root tr {
    transition: background 0.12s;
  }
  .MuiTableBody-root tr:hover {
    background: #fafbfc;
  }
  .MuiTableBody-root td {
    border-bottom: 1px solid #f1f5f9 !important;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
`;

const CardTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

const CardSubtitle = styled.div`
  margin-top: 2px;
  font-size: 12.5px;
  color: #64748b;
`;

const CountChip = styled.span`
  padding: 5px 12px;
  border-radius: 99px;
  background: ${COLORS.BTN_GREEN}14;
  color: ${COLORS.BTN_GREEN};
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
`;

const FileCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

const FileIcon = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${COLORS.BTN_GREEN}14;
  color: ${COLORS.BTN_GREEN};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Ellipsis = styled.span`
  display: block;
  min-width: 0;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LotChip = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 99px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 700;
`;

const OwnerCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const IconGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Avatar = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e0f2f1;
  color: ${COLORS.BTN_GREEN};
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const DateText = styled.span`
  color: #475569;
  white-space: nowrap;
`;

const Muted = styled.span`
  color: #94a3b8;
`;

const InvoiceActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  min-width: 0;
`;

const PillButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 99px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  transition: all 0.15s;
  border: 1px solid
    ${({ variant }) =>
      variant === "secondary" ? "#c7d2fe" : `${COLORS.BTN_GREEN}55`};
  background: ${({ variant }) =>
    variant === "secondary" ? "#eef2ff" : `${COLORS.BTN_GREEN}10`};
  color: ${({ variant }) =>
    variant === "secondary" ? "#4338ca" : COLORS.BTN_GREEN};
  &:hover {
    background: ${({ variant }) =>
      variant === "secondary" ? "#4338ca" : COLORS.BTN_GREEN};
    color: #fff;
  }
`;

const ApprovedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border-radius: 99px;
  background: #ecfdf5;
  color: #047857;
  font-size: 12.5px;
  font-weight: 600;
`;

const LotButton = styled.input`
  width: 100%;
  max-width: 80px;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  background: #f8fafc;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: #00838c;
  }
`;
